export interface ProjectSheetMediaItem {
	id: string;
	mediaType: "snapshot" | "recording";
	mediaUrl: string;
	thumbnailUrl: string;
}

interface MapProjectMediaForSheetPickerOptions {
	snapshots: any[];
	recordings: any[];
	existingMediaIds: Set<string>;
}

type UploadResult = {
	signedUrl?: string;
	signedUrlThumbnail?: string;
};

function parseUploadResult(uploadResult: unknown): UploadResult | null {
	if (!uploadResult) {
		return null;
	}

	if (typeof uploadResult === "string") {
		try {
			return JSON.parse(uploadResult) as UploadResult;
		} catch {
			return null;
		}
	}

	return uploadResult as UploadResult;
}

function getSnapshotMediaUrls(snapshot: any) {
	const uploadResult = parseUploadResult(snapshot.uploadResult);

	const mediaUrl = uploadResult?.signedUrl || snapshot.signedUrl || snapshot.url || "";
	const thumbnailUrl = uploadResult?.signedUrlThumbnail || snapshot.thumbnailSignedUrl || snapshot.signedUrl || snapshot.url || mediaUrl;

	return { mediaUrl, thumbnailUrl };
}

function getRecordingMediaUrls(recording: any) {
	const mediaUrl = recording.recordingUrl || recording.url || "";
	const thumbnailUrl = recording.thumbnailUrl || recording.privateThumbnailUrl || mediaUrl;

	return { mediaUrl, thumbnailUrl };
}

export function mapProjectMediaForSheetPicker({
	snapshots,
	recordings,
	existingMediaIds
}: MapProjectMediaForSheetPickerOptions): ProjectSheetMediaItem[] {
	const items: ProjectSheetMediaItem[] = [];

	for (const snapshot of snapshots || []) {
		if (existingMediaIds.has(snapshot.id)) {
			continue;
		}

		const { mediaUrl, thumbnailUrl } = getSnapshotMediaUrls(snapshot);

		items.push({
			id: snapshot.id,
			mediaType: "snapshot",
			mediaUrl,
			thumbnailUrl
		});
	}

	for (const recording of recordings || []) {
		const recordingId = recording.sourceId || recording.id;
		if (!recordingId || existingMediaIds.has(recordingId)) {
			continue;
		}

		const { mediaUrl, thumbnailUrl } = getRecordingMediaUrls(recording);

		items.push({
			id: recordingId,
			mediaType: "recording",
			mediaUrl,
			thumbnailUrl
		});
	}

	return items;
}
